"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
function getEventsToolkitEmitAPI() {
    if (process.env.NEXT_PUBLIC_EVENTS_TOOLKIT_EMIT_API) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return process.env.NEXT_PUBLIC_EVENTS_TOOLKIT_EMIT_API;
    }
    else if (process.env.EVENTS_TOOLKIT_EMIT_API) {
        // picking up the standard emit API configuration setting
        return process.env.EVENTS_TOOLKIT_EMIT_API;
    }
    else {
        // if nothing is set up, we'll default to production emitting
        // to ensure we do our best to capture the event data
        console.error("Toolkit emit API is not set. The emit API can be configured via the NEXT_PUBLIC_EVENTS_TOOLKIT_EMIT_API or " +
            "EVENTS_TOOLKIT_EMIT_API environment variables. Falling back to production endpoint: https://zapier.com/api/v4/tracking/event/");
        return "https://zapier.com/api/v4/tracking/event/";
    }
}
function getWriteToDataLayer() {
    if (process.env.NEXT_PUBLIC_EVENTS_TOOLKIT_WRITE_TO_DATA_LAYER) {
        // If we're running in a browser, we'll want to check for NEXT_PUBLIC_ variables
        // https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
        return process.env.NEXT_PUBLIC_EVENTS_TOOLKIT_WRITE_TO_DATA_LAYER;
    }
    else if (process.env.EVENTS_TOOLKIT_WRITE_TO_DATA_LAYER) {
        return process.env.EVENTS_TOOLKIT_WRITE_TO_DATA_LAYER;
    }
    else {
        return "false";
    }
}
exports.settings = {
    streaming_service: process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        ? process.env.EVENTS_TOOLKIT_STREAMING_SERVICE
        : "api",
    emit_api: getEventsToolkitEmitAPI(),
    domain: new URL(getEventsToolkitEmitAPI()).hostname,
    write_to_data_layer: getWriteToDataLayer(),
};
